<div>    
    <c-sidebar 
        #sidebar="cSidebar"
        id="sidebar"
        fixed
        class="d-print-none sidebar sidebar-dark sidebar-fixed"
        [ngClass]="{ 'sidebar-narrow-unfoldable': sidebarMinimized }"
        (visibleChange)="onVisibleChange($event)"
        visible>

        <c-sidebar-nav 
            [navItems]="getItems() | async" 
            dropdownMode="path">
        </c-sidebar-nav>
    </c-sidebar>
</div>    